import Handlebars from 'handlebars/dist/cjs/handlebars';

Handlebars.registerHelper('attr', function(name, concat, data) {
    var result = ' ' + name + '="' + concat + data +  '" ';

    return new Handlebars.SafeString(result);
});
